export const SUB_ROUTES = ["insights", "evaluation", "notes", "info"] as const;
